export const stationShortNumberDivider = '-';

export const getPosAppVersion = posappVersion => {
    if (!posappVersion) return '';

    let normalizedVersion = posappVersion;

    if (typeof normalizedVersion === 'string') {
        try {
            normalizedVersion = JSON.parse(normalizedVersion);
        } catch (error) {
            return '';
        }
    }

    if (!normalizedVersion || typeof normalizedVersion !== 'object') return '';

    const version = normalizedVersion['pos-version'];

    return typeof version === 'string' ? version.trim() : version || '';
};
